var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { TextField } from '@one-thd/sui-atomic-components';
import { Controller, useFormContext } from 'react-hook-form';
import { getTextFieldStatus } from '../../../utils/form';
import { getHyphenatedPhoneNumber } from '../../../utils/general';
import { PHONE_PLACEHOLDER } from '../../../constants/placeholders';
import { ZipCodeCitySelectFields } from '../zipcode/zipcode';
export const AddressFields = ({ children }) => {
    const formMethods = useFormContext();
    const { control, formState: { errors: formErrors }, } = formMethods;
    return (React.createElement(React.Fragment, null,
        React.createElement(Controller, { name: "firstName", control: control, render: ({ field }) => {
                var _a;
                const { ref, value, name, onChange } = field, rest = __rest(field, ["ref", "value", "name", "onChange"]);
                return (React.createElement(TextField, { label: "First Name*", status: getTextFieldStatus(formErrors.firstName), statusMessage: (_a = formErrors.firstName) === null || _a === void 0 ? void 0 : _a.message, value: value, name: name, onChange: onChange, InputProps: {
                        inputProps: Object.assign(Object.assign({}, rest), { 'data-qm-mask': '', 'data-testid': 'first-name-add-address' }),
                    } }));
            } }),
        React.createElement(Controller, { name: "lastName", control: control, render: ({ field }) => {
                var _a;
                const { ref, value, name, onChange } = field, rest = __rest(field, ["ref", "value", "name", "onChange"]);
                return (React.createElement(TextField, { label: "Last Name*", status: getTextFieldStatus(formErrors.lastName), statusMessage: (_a = formErrors.lastName) === null || _a === void 0 ? void 0 : _a.message, value: value, name: name, onChange: onChange, InputProps: {
                        inputProps: Object.assign(Object.assign({}, rest), { 'data-qm-mask': '', 'data-testid': 'last-name-add-address' }),
                    } }));
            } }),
        children,
        React.createElement(Controller, { name: "addressLine1", control: control, render: ({ field }) => {
                var _a;
                const { ref, value, name, onChange } = field, rest = __rest(field, ["ref", "value", "name", "onChange"]);
                return (React.createElement(TextField, { label: "Address*", status: getTextFieldStatus(formErrors.addressLine1), statusMessage: (_a = formErrors.addressLine1) === null || _a === void 0 ? void 0 : _a.message, value: value, name: name, onChange: onChange, InputProps: {
                        inputProps: Object.assign(Object.assign({}, rest), { 'data-qm-mask': '', 'data-testid': 'address-line-one-add-address' }),
                    } }));
            } }),
        React.createElement(Controller, { name: "addressLine2", control: control, render: ({ field }) => {
                var _a;
                const { ref, value, name, onChange } = field, rest = __rest(field, ["ref", "value", "name", "onChange"]);
                return (React.createElement(TextField, { label: "Address Line 2", status: getTextFieldStatus(formErrors.addressLine2), statusMessage: (_a = formErrors.addressLine2) === null || _a === void 0 ? void 0 : _a.message, optional: true, value: value || '', name: name, onChange: onChange, InputProps: {
                        inputProps: Object.assign(Object.assign({}, rest), { 'data-qm-mask': '', 'data-testid': 'address-line-two-add-address' }),
                    } }));
            } }),
        React.createElement(ZipCodeCitySelectFields, null),
        React.createElement(Controller, { name: "primaryPhone", control: control, render: ({ field }) => {
                var _a;
                const { ref, value, name, onChange } = field, rest = __rest(field, ["ref", "value", "name", "onChange"]);
                return (React.createElement(TextField, { label: "Phone*", status: getTextFieldStatus(formErrors.primaryPhone), statusMessage: (_a = formErrors.primaryPhone) === null || _a === void 0 ? void 0 : _a.message, placeholder: PHONE_PLACEHOLDER, value: value, name: name, onChange: (event) => {
                        onChange(getHyphenatedPhoneNumber(event.currentTarget.value || ''));
                    }, InputProps: {
                        inputProps: Object.assign(Object.assign({}, rest), { 'data-qm-mask': '', 'data-testid': 'primary-phone-add-address' }),
                    } }));
            } })));
};
